import { setSpecificMessage, ipv4 } from "valibot";
setSpecificMessage(
  ipv4,
  (issue) => `IPv4 invalide: reçu ${issue.received}`,
  "fr"
);